import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import Modal from './Modal';
import QRCodeComponent from '../widgets/QRCodeComponent';

function BiggerImageModal({ t, onClose, value, size }) {
  const handleClose = () => {
    onClose();
  };
  return (
    <Modal onClose={handleClose}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div id="modalBody" className="modal-body">
            <QRCodeComponent value={value} size={size} />
            <div className="modal-buttons">
              <div className="row justify-content-end">
                <div className="col-lg-3">
                  <button
                    type="button"
                    className="btn btn-dynamic"
                    onClick={handleClose}
                  >
                    {t('close')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

BiggerImageModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  value: PropTypes.string,
  size: PropTypes.number,
};
BiggerImageModal.defaultProps = {
  value: '',
  size: 256,
};

export default translate(BiggerImageModal);
